import gql from 'graphql-tag'

export default gql`
  fragment ProductListBlockFacetValueFragment on ProductListBlockFacetValue {
    id
    key
    name {
      ...WordbookFragment
    }
    color
  }

  fragment ProductListBlockFragment on ProductListBlock {
    header
    filters
    optionalFilters(boost: $boost)
    limit
    guidedFilters {
      __typename
      ... on IGuidedFilter {
        asset {
          ...ReferenceContent
        }
        backgroundColor
        textColor
        priority
        component
        variant
        header {
          value
        }
        text {
          value
        }
      }
      ... on GuidedFilterAttributeEnum {
        __typename
        attribute
        parameter
        items {
          ... on IGuidedFilterItem {
            backgroundColor
            textColor
            priority
          }
          asset {
            ...ReferenceContent
          }
          key
          canonical
        }
      }
      ... on GuidedFilterLinkResource {
        __typename
        items {
          ... on IGuidedFilterItem {
            backgroundColor
            textColor
            priority
          }
          link {
            ...BlockLinkFragment
          }
        }
      }
    }
    topLinks {
      id
      image {
        url
      }
      imageMobile {
        url
      }
      url
      newTab
      queryParameters
      references {
        ... on Page {
          id
          type
          title
        }
      }
    }
    looks {
      id
      ambassadorHandle
      asset {
        ...ReferenceContent
      }
      products {
        productID
        x
        y
      }
    }
    description {
      ...BlockRTEFieldFragment
    }
    display
    boosts
    facets
    filter
    facetConfig {
      id
      key
      parameter
      type
      name {
        defaults
      }
      facetDescriptionButton {
        ...WordbookFragment
      }
      facetDescriptionIDs
      values {
        ...ProductListBlockFacetValueFragment
      }
      groups {
        id
        key
        name {
          ...WordbookFragment
        }
        values {
          ...ProductListBlockFacetValueFragment
        }
      }
    }
  }
`
